module.exports = __webpack_public_path__ + "img/ios_tips_btn.f111780f.png";